import { render, staticRenderFns } from "./VendorContacts.vue?vue&type=template&id=937cd542"
import script from "./VendorContacts.vue?vue&type=script&lang=js"
export * from "./VendorContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports